import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

function Header({ pageName }) {
    const navigate = useNavigate();
    const [usersData, setUsersData] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            const decoded = jwtDecode(token);
            setUsersData(decoded);
        }
    }, []);

    return (
        <div className="topbar">
            <div className="topbar-title">
                {pageName || ""}
            </div>
            <div className="topbar-actions">
                <button className="notif-btn" onClick={() => navigate("/messages")}>
                    <div className="notif-dot"></div>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                </button>
                <div className="avatar" onClick={() => navigate("/profile")}>
                    {usersData?.full_name
                        ?.trim()
                        ?.split(" ")
                        ?.map(word => word[0])
                        ?.join("")
                        ?.slice(0, 2)
                        ?.toUpperCase() || "?"}
                </div>
            </div>
        </div>
    )
}

export default Header;
